import _ from 'lodash';
import store from '../store';
import { compareStringIgnoreCase } from '@/utils';
import { standardFunctions } from '@/helpers/standardFunctions';

export function expectedProgress(productionReport: any, progressArray: any[]): { currentProgress: number, expectedProgress: number } {
  const currentProcessProgress = progressArray.find((progress: any) => progress.index == _.get(productionReport, 'process._key'));
  const { netWeight, progress } = currentProcessProgress;
  let producedQty = currentProcessProgress.producedQty;
  _.forEach(productionReport.process.outputs, (output: any) => {
    if(productionReport.process.type === 'Packing') {
      producedQty += standardFunctions['kgToPcs'](_.get(output, 'report.quantity', 0), store.getters.getGoodFromId(output._id))
    } else {
      let quantity = _.get(output, 'report.quantity', 0);
      const goodsObject = store.getters.getGoodFromId(output._id);
      if(compareStringIgnoreCase(_.get(goodsObject, 'rawMaterialUnit', ''),'SQM')) {
        quantity = standardFunctions['kgToSQM'](quantity, goodsObject);
      } 
      producedQty = producedQty + quantity;
    }
  })
  const currentProgress = _.round(progress);
  const expectedProgress = _.round((producedQty/netWeight)*100);
  return { currentProgress, expectedProgress };
}